<template>
  <div class="layout-pc">
    <div class="list">
      <div
        v-infinite-scroll="loadMore"
        infinite-scroll-disabled="busy"
        infinite-scroll-distance="10"
      >
        <ax-cell
          v-for="(item, index) in data"
          :key="index"
          :axData="item"
          @click.native="showDetail(index)"
          :class="{active:index === idx}"
        />
        <div v-show="!data.length">
          <ax-skeleton v-for="index in 5" :key="index" />
        </div>
      </div>
      <div class="loading" v-show="!busy && data.length">
        <van-loading color="#0BB7BE"/>
      </div>
    </div>
    <div class="layout-content">
      <div class="header">
        <van-icon v-show="iframeType === 'details'" name="arrow-left" @click="back" />
        <van-icon v-show="iframeType === 'record'" name="arrow-left" @click="iframeType = 'details';title = '审批详情'" />
        <p>{{title}}</p>
        <span>
          <van-icon v-if="hasRecord" name="records" @click="showRecord" />
        </span>
      </div>
      <div class="content">
        <iframe v-show="iframeType === 'details'" @load="handleEle" ref="iframe" :src="src" frameborder="0"></iframe>
        <iframe v-show="iframeType === 'record'" :src="recordSrc" frameborder="0"></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import infiniteScroll from 'vue-infinite-scroll';
import{ Loading } from 'vant'
const cell = () => import('@/views/Workbench/approve/cell.vue');
const skeleton = () => import('@/views/Workbench/approve/skeleton.vue')
import { fetchData } from '@/api/workbench'
export default {
  name: 'upcoming',
  directives: { infiniteScroll },
  components: {
    'ax-cell' :cell,
    'ax-skeleton' :skeleton,
    Loading
  },
  data() {
    return {
      data: [],
      busy: false,
      count: 1,
      title: '审批详情',
      src: '',
      recordSrc: '',
      iframeType: 'details',
      idx: 0,
      pageNo: 0,
      processTodo: '',
      total: '',
      hasRecord: true
    };
  },
  methods: {
    handleEle(){
      const iframe = this.$refs.iframe.contentWindow;
      iframe.document.getElementsByTagName('html')[0].classList.add('nested');
      iframe.document.getElementsByTagName('html')[0].style.fontSize = '37.5px';
    },
    loadMore() {
      this.busy = true;
      if(this.pageNo === 1){
        this.showDetail(0)
      }
      if(this.total === this.data.length){
        return
      }
      this.pageNo ++;
      fetchData('getUpComingList',{
        pageSize: 10,
        pageNo: this.pageNo
      },{
        processTodo : this.processTodo
      }).then((res)=>{
        const { success , data } = res.data;
        if(success){
          this.total = data.total;
          this.$emit('setCount', this.total)
          if(data.processToDoList.length !== 0){
            this.busy = false;
            this.data = this.data.concat(data.processToDoList)
          }else{
            this.busy = true
          }
        }
      }).catch((err)=>{
        this.busy = true;
      })
    },
    showDetail(index){
      this.idx = index;
      this.getDetailsUrl(this.data[index].detailUrl,this.data[index].historyUrl)
      this.iframeType = 'details';
      this.data[index].platform === 'HULK'?this.hasRecord = false:this.hasRecord = true;
    },
    showRecord(){
      this.iframeType = 'record'
      this.title = '审批记录'
    },
    back(){
      const iframe = this.$refs.iframe.contentWindow;
      if((iframe.location.pathname + iframe.location.search) == this.src){
        return
      }
      iframe.history.back();
    },
    handleMessage (event) {
      // 根据上面制定的结构来解析iframe内部发回来的数据
      if(event.data.params){
        const { success, index } = event.data.params;
        if(success){
          this.data.splice(index,1);
          this.showDetail(0)
          this.$emit('setCount', this.data.length)
        }
      }
    },
    getDetailsUrl(url,recordUrl){
      fetchData('getDetailsUrl', {
        redirect_uri: url
      }).then((res)=>{
        const {success , data} = res.data;
        if(success){
          this.src = data+'&indexId='+this.idx;
        }
      }).catch(()=>{
        console.log('网络连接失败')
      })
      fetchData('getDetailsUrl', {
        redirect_uri: recordUrl
      }).then((res)=>{
        const {success , data} = res.data;
        if(success){
          this.recordSrc = data;
        }
      }).catch(()=>{
        console.log('网络连接失败')
      })
    }
  },
  mounted () {
    // 在外部vue的window上添加postMessage的监听，并且绑定处理函数handleMessage
    window.addEventListener('message', this.handleMessage);    
  },
  destroyed () {
      // 注意移除监听！
    window.removeEventListener('message', this.handleMessage)
  }  
};
</script>
<style lang="scss">
  .list .active{
    background:rgba(240,247,247,1);
  }
</style>
